/* Keep the full introduction visible; collapse from the benefits heading. */
if (!customElements.get('yoko-mobile-description')) {
  customElements.define('yoko-mobile-description', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.enhance(), { once:true });
      } else {
        this.enhance();
      }
    }

    enhance() {
      if (this.dataset.enhanced) return;
      const content = this.querySelector('[data-yoko-description-content]');
      const template = this.querySelector('template[data-yoko-description-disclosure]');
      if (!content || !template) return;

      const benefitHeadings = new Set([
        'priekšrocības', 'galvenās priekšrocības', 'ieguvumi',
        'benefits', 'key benefits', 'advantages',
        'преимущества', 'основные преимущества',
        'eelised', 'peamised eelised',
        'hyödyt', 'edut', 'tärkeimmät hyödyt',
        'privalumai', 'pagrindiniai privalumai',
        'zalety', 'korzyści', 'główne zalety'
      ]);
      const boundary = Array.from(content.querySelectorAll('h1,h2,h3,h4,h5,h6')).find(heading =>
        benefitHeadings.has(heading.textContent.normalize('NFKC').replace(/\s+/g, ' ').trim().replace(/[:：]$/, '').trim().toLowerCase())
      );
      // Without a benefits section, keep the complete original description visible.
      if (!boundary) return;

      const details = template.content.firstElementChild.cloneNode(true);
      const body = details.querySelector('.yoko-mobile-description__body');
      const range = document.createRange();
      range.setStart(content, 0);
      range.setEndBefore(boundary);
      const introduction = range.extractContents();
      // Ranges balance nested wrappers; retain only one copy of a split wrapper's ID.
      const introIds = new Set(Array.from(introduction.querySelectorAll('[id]'), node => node.id));
      content.querySelectorAll('[id]').forEach(node => {
        if (introIds.has(node.id)) node.removeAttribute('id');
      });
      while (content.firstChild) body.appendChild(content.firstChild);
      content.appendChild(introduction);
      template.replaceWith(details);
      this.dataset.enhanced = 'true';
    }
  });
}
